import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'

const state = {
  message: {
    content: '',
    type: ''
  },
  redirectToLogin: false
}

const actions = {

  async getInitData ({ dispatch, state, commit }) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    let type = 'success'
    const response = await ApiManager.request('User').userSelf()
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      // commit('setUser', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
    return response.data.data
  },
  /**
   * 自分自身の情報の更新処理を行う
   */
  async updateSetting ({ state, commit }, user) {
    this.dispatch('loading/loadingPagePlus')
    const payload = Object.assign({}, user)
    commit('init')
    payload.waitFlag = parseInt(payload.waitFlag)
    payload.infoFlag = parseInt(payload.infoFlag)
    const response = await ApiManager.request('User').userEditMe(payload)
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      this.dispatch('account/updateLocalUser', user)
      commit('setRedirectToLogin', response.data.meta.redirect_to_login)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setMessage (state, data) {
    state.message = data
  },
  setRedirectToLogin (state, redirectToLogin) {
    state.redirectToLogin = redirectToLogin
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
